import { useEffect, useState } from 'react';
import { getBillingAccess } from './billingAccess';

export function useBillingAccess(user) {
    const [now, setNow] = useState(Date.now);
    useEffect(() => {
        const refresh = () => setNow(Date.now());
        const timer = setInterval(refresh, 15000);
        window.addEventListener('focus', refresh);
        return () => { clearInterval(timer); window.removeEventListener('focus', refresh); };
    }, []);
    return getBillingAccess(user, now);
}

export const billingStateLabel = (access, plan = {}) => ({
    active: plan.cancelAtPeriodEnd ? 'Renewal cancelled' : 'Active',
    trial: 'Existing trial',
    grace: 'Payment overdue — grace period',
    expired: 'Subscription expired',
    reconciliation_required: 'Payment verification needed',
    awaiting_payment: 'First payment required',
    awaiting_approval: 'Awaiting approval',
}[access.state] || 'Billing needs attention');

export const billingExplanation = (access, plan = {}) => {
    const date = value => value ? new Intl.DateTimeFormat('en-ZA', { dateStyle: 'medium' }).format(new Date(value)) : 'the end of your paid period';
    if (access.state === 'active' && plan.cancelAtPeriodEnd) return `Your subscription will not renew. Your listing and new intake remain available until ${date(access.paidThroughAt)}. Existing work and billing remain accessible afterwards.`;
    if (access.state === 'grace') return `Your renewal payment failed. Your listing and new intake remain available during the seven-day grace period, until ${date(access.graceUntilAt)}. Update your payment details to continue.`;
    if (access.state === 'trial') return `Your existing trial is honored until ${date(plan.trialEndsAt)}. No new free trial is added.`;
    if (access.state === 'reconciliation_required') return 'We need to verify your previous payment period. Your listing and new intake are paused. Existing jobs, unexpired files, enquiries and billing remain accessible. Contact support if your payment has already succeeded.';
    if (access.state === 'expired') return 'Your listing and new jobs or enquiries are paused. You can still finish existing jobs, download unexpired files, read enquiries and manage billing.';
    if (access.state === 'active') return `Your subscription renews automatically each month. Your verified paid period ends ${date(access.paidThroughAt)}.`;
    return 'Your listing becomes public after approval and verified first payment.';
};
